import ButtonLoader from 'components/common/ButtonLoader';
import { CurrencySymbol, formatPlanType } from 'components/common/Utils';
import { formatDate } from "helpers/common_helpers";
import checkedIcon from '../../../../assets/images/icons/checked.svg'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { calculateUpgradePlanSubscription, myCurrentSubscription, upgradePlan } from 'store/actions/subscriptionSlice';
import { showAlert } from 'store/reducers/alertReducer';


function PlanUpgrade(
  {
    planType,
    selectedPlan,
    setPlanType,
    setselectedPlan,
    handleClose
  }
) {
  const { t ,i18n } = useTranslation();
  const {
    isLoading,
    allPlans,
    mySubscriptionDetails,
    subscriptionCalculationResponse,
  } = useSelector(
    (state) => state.Subscriptions
  );

  const dispatch = useDispatch();
  useEffect(() => {
    getCalculations();
  }, [selectedPlan]);
  const getCalculations = (code = "") => {
    const payload = {
      subscriptionId: mySubscriptionDetails?._id,
      billingCycle: mySubscriptionDetails?.billingCycle,
      planId: selectedPlan?.id,
    };
    dispatch(calculateUpgradePlanSubscription(payload))
      .then((action) => {
        const { statusCode, success, message, data } = action?.payload || {};
        const { discountedAmount } = data || {};
        if (statusCode === 200 && success) {

        } else {
          dispatch(
            showAlert({
              text: message,
              type: "error",
            })
          );
        }
      })
      .catch((err) => {
        if (code) {
          // setAppliedCode("");
          // setCouponMessage("Failed to apply coupon");
        }
      });
  };
  const handleConfirm = () => {

    const payload = {
      subscriptionId: mySubscriptionDetails._id,
      planId: selectedPlan.id,
      billingCycle: selectedPlan.billingCycle,
      code: ""
    };

    dispatch(upgradePlan(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload || {};
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          dispatch(myCurrentSubscription());

          handleClose();
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => { });
  };
  const payableAmount = subscriptionCalculationResponse?.calculation?.payableAmount;

  return (
    <section className="plan_upgrade my_plan_page ">
      <h2 className="fs_24 text_primary">{t("Confirm your updates")}</h2>
      <div className="common_card_2 mt-0">
        <div className="g_between gap-3 align-items-start flex-wrap">
          <div className="plan_div align-items-start">
            <div className="box"></div>
            <div>
              <h2 className="fs_12 text_dark_gray">{t("Plan")}</h2>
              <h2 className="fs_20 text_black text-capitalize">
                {
                  mySubscriptionDetails.cancelledInfo?.isCancelled ?
                    t("No Active Plan") :
                    mySubscriptionDetails.isTrial ? "Free trial" : mySubscriptionDetails.billingCycle
                }
                {mySubscriptionDetails.cancelledInfo?.isCancelled && (
                  <h6 className="cancelled_text fs_14 text_danger">
                    Cancelled
                    {mySubscriptionDetails?.status !== 3 &&
                      `- active until ${formatDate(
                        mySubscriptionDetails?.billingCycleEnd
                      )}`}
                  </h6>
                )}
              </h2>
            </div>
          </div>

        </div>
        <div className="plan_details">
          <div className="single_details">
            <h2 className="fs_12 text_dark_gray">{t("Due On")}</h2>
            <h2 className="fs_14 text_black_3">
              {formatDate(mySubscriptionDetails?.trialEndDate)}
            </h2>
          </div>
          <div className="single_details">
            <h2 className="fs_12 text_dark_gray">{t("Locations")}</h2>
            <h2 className="fs_14 text_black_3">
              {mySubscriptionDetails?.features?.locations}
            </h2>
          </div>
          <div className="single_details">
            <h2 className="fs_12 text_dark_gray">{t("Members")}</h2>
            <h2 className="fs_14 text_black_3">
              {mySubscriptionDetails?.features?.members}
            </h2>
          </div>
          <div className="single_details">
            <h2 className="fs_12 text_dark_gray">{t("Charged")}</h2>
            <h2 className="fs_14 text_black_3">
              {mySubscriptionDetails?.planId?.name}
            </h2>
          </div>
        </div>
      </div>
      <div className="switch_div">
        <h2>{t("Switch to")}</h2>
        {/* <button
          className={planType === "Starter" ? "active" : ""}
          onClick={() =>
            setPlanType("Starter")
          }
        >
          {t("Starter")}
        </button> */}
        <button
          className={planType === "Professional" ? "active" : ""}
          onClick={() =>
            setPlanType("Professional")
          }
        >
          {t("Professional")}
        </button>
      </div>
      <div className="plan">
        <div className="duration text_black2">
          <h6 className="bold">
            {t(formatPlanType(selectedPlan.name))}
          </h6>
        </div>
        <div className="plan_features">
          <div className="single_details">
            <h2 className="fs_12 text_dark_gray">{t("Members")}</h2>
            <h2 className="fs_14 text_black_3">
              {selectedPlan?.limits?.members}
            </h2>
          </div>
          <div className="single_details">
            <h2 className="fs_12 text_dark_gray">{t("Locations")}</h2>
            <h2 className="fs_14 text_black_3">
              {selectedPlan?.limits?.locations}
            </h2>
          </div>
        </div>
        <div className="plan_benefits_points">
          <ul>
            {selectedPlan.features.map((feature) => (
              <li key={feature._id}>
                <img src={checkedIcon} width={20} height={20} alt="Work Space Logo" />
                <span>
                  {i18n.language === "ar"
                    ? feature.titleAr
                    : feature.title}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="amount_due_now">
          <div className="g_between">
            <div>
              <h2 className="fs_16">{t("Amount Due Now")}</h2>
              <span className="vat_label">
                {t("Includes VAT")} {subscriptionCalculationResponse?.calculation?.vatValue}
              </span>
            </div>
            <h3 className="fs_20 payable_amount d-flex gap-1 align-items-center ltr">
              <CurrencySymbol width="16" height="18" color={"#6FB7ED"} />
              {payableAmount}
            </h3>
          </div>
        </div>
        <div className="buttons">
          <button
            className="continue g_center gap-2 main_btn"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {t("Confirm")}
            {isLoading && <ButtonLoader />}
          </button>
          <button className="back" onClick={handleClose}>
            {t("Go Back")}
          </button>
        </div>
      </div>

    </section>
  )
}

export default PlanUpgrade
